export default __webpack_public_path__ + "static/media/arrow-right-icon.a596352c.svg";